export default {
  BASE_URL: '',
  api: [
    {
      name: 'parentCategory',
      method: 'GET',
      desc: '获取招标类目',
      path: '/category/module/category'
    },
    {
      name: 'getSuppliers',
      method: 'GET',
      desc: '简易标书邀请供应商列表',
      path: '/crmMember/getSuppliers'
    },
    {
      name: 'addSimpleBid',
      method: 'POST',
      desc: '保存简易标书',
      path: '/bid/addSimpleBid'
    },
    {
      name: 'postSimpleBid',
      method: 'POST',
      desc: '提交简易标书',
      path: '/bid/postSimpleBid'
    },
    {
      name: 'checkIsCert',
      method: 'GET',
      desc: '提交简易标书',
      path: '/bid/checkIsCert'
    },
    {
      name: 'nameIsExist',
      method: 'GET',
      desc: '检查标书名称是否重复',
      path: '/bid/nameIsExist'
    },
    {
      name: 'checkCustomTender',
      method: 'GET',
      desc: '检查是否有被定向邀标邀中',
      path: '/tender/checkCustomTender'
    },
    {
      name: 'openTender',
      method: 'GET',
      desc: '检查是否有权限投标',
      path: '/tender/openTender'
    },
    {
      name: 'addTender',
      method: 'PUT',
      desc: '提交标书',
      path: '/tender/addTender'
    },
    {
      name: 'postTender',
      method: 'PUT',
      desc: '保存标书',
      path: '/tender/postTender'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/easyBid.js